import { useEffect, useRef, useState } from 'react';
import { estimateRecipients } from '../../../../services/emailRecipientService';

// Debounces recipient-filter changes and calls the backend estimate endpoint for a live count.
export default function useRecipientEstimate(filterPayload, delay = 500) {
    const [estimatedCount, setEstimatedCount] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const timerRef = useRef(null);

    useEffect(() => {
        const hasCriteria = filterPayload?.criteria?.length > 0 || filterPayload?.manualEmails?.length > 0;
        if (!hasCriteria) {
            setEstimatedCount(0);
            return;
        }

        setLoading(true);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(async () => {
            try {
                const result = await estimateRecipients(filterPayload);
                setEstimatedCount(result?.estimatedCount ?? 0);
                setError(null);
            } catch (err) {
                setError(err.message || 'Failed to estimate recipients');
            } finally {
                setLoading(false);
            }
        }, delay);

        return () => clearTimeout(timerRef.current);
    }, [JSON.stringify(filterPayload), delay]);

    return { estimatedCount, loading, error };
}
